// removed by extract-text-webpack-plugin
module.exports = {"circleButton":"_2gP_-"};